import { Link } from 'react-router';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { useFirestoreDoc } from '../hooks/useDashboardData';
import { COLLECTIONS } from '../../lib/firebase';

export default function Footer() {
  const { data: settings } = useFirestoreDoc<any>(COLLECTIONS.SITE_SETTINGS, 'general');

  const siteInfo = {
    phone: settings?.contactNumber || '+91 91409 81723',
    email: settings?.supportEmail || 'info@postproperty.in',
    address: settings?.officeAddress || 'Shop No.2, Highway Ashirwad Chs, Korum mall service road, Junction, near Nitin, Thane, Maharashtra 400604',
    siteName: settings?.siteName || 'Post Property'
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200" role="contentinfo" aria-label="Site footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">

          {/* Brand */}
          <div>
            <div className="flex flex-col mb-4">
              <img
                src="/logo.png"
                alt="Post Property Mumbai – Real Estate Agents in Mumbai"
                className="h-24 w-auto mb-2 mix-blend-multiply"
                loading="lazy"
                width={96}
                height={96}
              />
            </div>
            <p className="text-gray-600 mb-4">
              Your trusted partner in finding the perfect property in Mumbai and Thane.{' '}
              {siteInfo.siteName} makes real estate simple.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                aria-label="Follow Post Property Mumbai on Facebook"
                className="p-2 rounded-full hover:bg-gray-200 transition-colors"
                style={{ color: 'var(--brand-blue)' }}
              >
                <Facebook className="w-5 h-5" aria-hidden="true" />
              </a>
              <a
                href="#"
                aria-label="Follow Post Property Mumbai on Instagram"
                className="p-2 rounded-full hover:bg-gray-200 transition-colors"
                style={{ color: 'var(--brand-blue)' }}
              >
                <Instagram className="w-5 h-5" aria-hidden="true" />
              </a>
              <a
                href="#"
                aria-label="Connect with Post Property Mumbai on LinkedIn"
                className="p-2 rounded-full hover:bg-gray-200 transition-colors"
                style={{ color: 'var(--brand-blue)' }}
              >
                <Linkedin className="w-5 h-5" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Quick links footer navigation">
            <h3 className="font-semibold mb-4" style={{ color: 'var(--brand-blue)' }}>Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-gray-900 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/properties" className="text-gray-600 hover:text-gray-900 transition-colors">
                  Properties in Mumbai
                </Link>
              </li>
              <li>
                <Link to="/properties?type=Buy" className="text-gray-600 hover:text-gray-900 transition-colors">
                  Buy Property Mumbai
                </Link>
              </li>
              <li>
                <Link to="/properties?type=Rent" className="text-gray-600 hover:text-gray-900 transition-colors">
                  Rent Flat in Mumbai
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </nav>

          {/* Services */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: 'var(--brand-blue)' }}>Our Services</h3>
            <ul className="space-y-2 text-gray-600">
              <li>Property Buying in Mumbai</li>
              <li>Property Selling</li>
              <li>1BHK &amp; 2BHK Rentals</li>
              <li>Commercial Property Mumbai</li>
              <li>Property Management</li>
              <li>Home Loans Assistance</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: 'var(--brand-blue)' }}>Contact Us</h3>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: 'var(--brand-pink)' }} aria-hidden="true" />
                <div>
                  <a href={`tel:${siteInfo.phone}`} className="hover:text-gray-900 transition-colors">
                    {siteInfo.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: 'var(--brand-pink)' }} aria-hidden="true" />
                <a href={`mailto:${siteInfo.email}`} className="hover:text-gray-900 transition-colors">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: 'var(--brand-pink)' }} aria-hidden="true" />
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">
              © {new Date().getFullYear()} {siteInfo.siteName}. All rights reserved. | Real Estate Agents in Mumbai
            </p>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="#" className="hover:text-gray-900 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-gray-900 transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-gray-900 transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
